import _styled from "@emotion/styled-base";
import React from 'react';
import { jsx } from '@emotion/core';
import OutsideClickHandler from 'react-outside-click-handler';
import { Search as SearchInput } from '../../Search';
import { Wrapper, Header, Footer, Content, Select, Item } from './styled';
import { Checkbox } from '../../Checkbox';
import { COLORS } from '../../../constants';

var StyledSelectAll = _styled("div", {
  target: "e151ad70",
  label: "StyledSelectAll"
})({
  padding: 8,
  borderBottom: "1px solid " + COLORS.grays.cardBorder
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Dropdown = function Dropdown(_a) {
  var _b = _a.handle,
      handle = _b === void 0 ? 'handle' : _b,
      _c = _a.footer,
      footer = _c === void 0 ? null : _c,
      _d = _a.toggled,
      toggled = _d === void 0 ? false : _d,
      _e = _a.onOutsideClick,
      onOutsideClick = _e === void 0 ? function () {} : _e,
      children = _a.children,
      search = _a.search,
      multiple = _a.multiple,
      selectAll = _a.selectAll;
  return jsx(Wrapper, null, jsx(OutsideClickHandler, {
    onOutsideClick: onOutsideClick
  }, handle, toggled && jsx(Select, {
    "aria-label": "Select navigation item"
  }, search && jsx(Header, null, jsx(SearchInput, {
    size: "small",
    placeholder: search.searchPlaceholder,
    onChange: search.onSearchChange,
    value: search.searchQuery,
    onSubmit: function onSubmit() {}
  })), multiple && selectAll && jsx(StyledSelectAll, null, jsx(Checkbox, {
    indeterminate: selectAll.indeterminate,
    checked: selectAll.checked,
    onChange: selectAll.onChange
  }, selectAll.text)), jsx(Content, null, React.Children.toArray(children).map(function (c) {
    return jsx(Item, {
      key: c.key
    }, c);
  })), footer && jsx(Footer, null, footer))));
};

export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/dropdown/index.js
// module id = 335
// module chunks = 0